import React from "react";

import { Page } from "components/Page";

export const NotFound = () => {
  return (
    <Page>
      <div className="flex h-full flex-col items-center">
        <div className="mt-10 flex flex-col gap-6 text-center">
          <h2 className="text-9xl font-extrabold text-neutral-500">
            <span className="sr-only">Error</span>404
          </h2>
          <p className="md:text-2 text-xl">Sorry, we couldn't find this page.</p>
          <a
            href="/products"
            className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Take me out
          </a>
        </div>
      </div>
    </Page>
  );
};
